import React from "react";
import LogoutHeader from '../../components/Headers/LogoutHeader';
import LogoutFooter from '../../components/Footers/LogoutFooter';
import SetPassword from '../../components/SetPassword';
import { Container, Row, Col } from 'react-bootstrap';

const SetPasswordPage = () => {
  return (
    <>  
      <LogoutHeader />
      <main className="section-spaces">
        <Container>
          <Row className="justify-content-center">
            <Col lg={8}>
              <SetPassword />
            </Col>
          </Row>
        </Container> 
      </main>
      <LogoutFooter />
    </>
  );
}

export default SetPasswordPage;